import React from "react";
import { useData } from "@/context/DataContext";

// Tonos oscuros: texto blanco con contraste ≥ 4,5:1 en todos.
export const PALETA = [
  { id: "verde", label: "Verde", hex: "#2F7D32" },
  { id: "azul", label: "Azul", hex: "#1D4ED8" },
  { id: "granate", label: "Granate", hex: "#7F1D1D" },
  { id: "morado", label: "Morado", hex: "#6D28D9" },
  { id: "naranja", label: "Naranja tostado", hex: "#B45309" },
  { id: "petroleo", label: "Azul petróleo", hex: "#0E5A6B" },
  { id: "rosa", label: "Rosa oscuro", hex: "#BE185D" },
  { id: "marron", label: "Marrón", hex: "#6B4423" },
];
export const colorHex = (id) => (PALETA.find((c) => c.id === id) || { hex: "#4A5550" }).hex;

const PARTICULAS = new Set(["de", "del", "la", "las", "los", "el", "y", "e", "da", "do", "van", "von"]);
export const iniciales = (nombre) => {
  const ps = (nombre || "").trim().split(/[\s-]+/).filter((w) => w && !PARTICULAS.has(w.toLocaleLowerCase("es")));
  const ini = ps.slice(0, 2).map((w) => Array.from(w)[0]).join("");
  return (ini || "?").toLocaleUpperCase("es");
};

const TAM = { xs: "w-6 h-6 text-[10px]", sm: "w-8 h-8 text-xs", md: "w-12 h-12 text-lg", lg: "w-16 h-16 text-2xl" };
export const Avatar = ({ persona, size = "sm", className = "", testid }) => {
  if (!persona) return null;
  return (
    <span role="img" aria-label={persona.name} title={persona.name} data-testid={testid}
      className={`${TAM[size]} shrink-0 rounded-full text-white font-heading font-bold inline-flex items-center justify-center leading-none ${className}`}
      style={{ backgroundColor: colorHex(persona.color) }}>
      <span aria-hidden="true">{iniciales(persona.name)}</span>
    </span>
  );
};

export const usePersona = (id) => {
  const { familyMembers = [] } = useData();
  return familyMembers.find((f) => f.id === id);
};

// Círculo + nombre. Si no cabe el nombre se trunca, pero el círculo y el nombre accesible se mantienen.
export const PersonaChip = ({ id, persona, size = "xs", className = "", testid }) => {
  const fm = usePersona(id);
  const p = persona || fm;
  if (!p) return null;
  return (
    <span className={`inline-flex items-center gap-1.5 min-w-0 max-w-full ${className}`} data-testid={testid}>
      <Avatar persona={p} size={size} />
      <span className="truncate" aria-hidden="true">{p.name}</span>
    </span>
  );
};

// Para selectores nativos: muestra el círculo de la persona elegida junto al desplegable.
export const ConAvatar = ({ id, children }) => {
  const p = usePersona(id);
  return <div className="flex items-center gap-2.5">{p && <Avatar persona={p} size="md" />}<div className="flex-1 min-w-0">{children}</div></div>;
};

// Personas de un elemento de agenda (solo si hay más de una persona en la cuenta).
export const Personas = ({ ids }) => {
  const { familyMembers = [] } = useData();
  const ps = (ids || []).map((id) => familyMembers.find((f) => f.id === id)).filter(Boolean);
  if (familyMembers.length < 2 || !ps.length) return null;
  return <span className="mt-1 flex flex-wrap gap-x-3 gap-y-1 text-sm font-semibold text-[#4A5550]">{ps.map((p) => <PersonaChip key={p.id} persona={p} size="xs" testid={`chip-persona-${p.id}`} />)}</span>;
};
